export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="bg-gradient-to-r from-primary-100/60 via-background-100 to-accent-100/40 rounded-2xl p-8 md:p-10 text-center border border-background-200/50">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-background-50"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              无论您是漫画家、版权方还是热心读者，欢迎通过以下方式与我们取得联系。
              投稿合作、意见反馈、友情链接申请，我们都会认真查看每一条信息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:contact@beilecomic.com"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
              <span className="text-sm text-foreground-500">contact@beilecomic.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}